import ApiService from "../api";

export default class TipoFornecedorService extends ApiService {

    constructor() {
        super('/api/tipo-fornecedores')
    }

    listar() {
        return this.get("");
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}